import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { ResizableHandle, ResizablePanel, ResizablePanelGroup } from '../../../../web/components-v2/Resizable';
import { styleSheet } from './styles';

// Initial width of the editor (left) pane as a percentage of the split. Both panes are
// freely drag-resizable from here, each constrained to MinPaneSizePx.
const DefaultLeftPaneSize = '33%';
// Minimum width of either pane, in pixels (react-resizable-panels treats bare numbers as px).
const MinPaneSizePx = 200;

export function HostedBlogPreviewSplitView({
	styles = [],
	leftNode,
	rightNode,
}: {
	styles?: StyleDeclarationValue[];
	leftNode?: React.ReactNode;
	rightNode?: React.ReactNode;
}) {
	return (
		<ResizablePanelGroup orientation='horizontal' styles={styles}>
			<ResizablePanel defaultSize={DefaultLeftPaneSize} minSize={MinPaneSizePx}>
				<div className={css(styleSheet.splitViewWindow)}>{leftNode}</div>
			</ResizablePanel>
			<ResizableHandle withHandle />
			<ResizablePanel minSize={MinPaneSizePx}>
				<div className={css(styleSheet.splitViewWindow)}>{rightNode}</div>
			</ResizablePanel>
		</ResizablePanelGroup>
	);
}
